const navLinks = [
  {
    id: "homeSection",
    title: "Home"
  },
  {
    id: "featureSection",
    title: "Features"
  },
  {
    id: "pricingSection",
    title: "Pricing"
  }
];

export default navLinks;
